var _excluded = ["value", "children", "onDrag", "tipFormatter", "arrowPointAtCenter"],
  _excluded2 = ["tipFormatter", "tipProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import raf from 'rc-util/lib/raf';
import React, { useEffect, useRef, useState } from 'react';
import styles from "./silderTooltipStyle";
import { ArrowCenterPlacementAlignMap, DisableAutoArrowList, MAX_VERTICAL_CONTENT_RADIUS, PlacementAlignMap } from "./types";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var HandleTooltip = function HandleTooltip(props) {
  var value = props.value,
    children = props.children,
    onDrag = props.onDrag,
    _props$tipFormatter = props.tipFormatter,
    tipFormatter = _props$tipFormatter === void 0 ? function (val) {
      return val;
    } : _props$tipFormatter,
    _props$arrowPointAtCe = props.arrowPointAtCenter,
    arrowPointAtCenter = _props$arrowPointAtCe === void 0 ? false : _props$arrowPointAtCe,
    restProps = _objectWithoutProperties(props, _excluded);
  var tooltipRef = useRef();
  var rafRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    _visible = _useState2[0],
    setVisble = _useState2[1];
  function cancelKeepAlign() {
    raf.cancel(rafRef.current);
  }
  function keepAlign() {
    rafRef.current = raf(function () {
      if (tooltipRef.current) {
        tooltipRef.current.forceAlign();
      }
    });
  }
  useEffect(function () {
    if (_visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }
    return cancelKeepAlign;
  }, [value, _visible]);
  useEffect(function () {
    setVisble(onDrag);
  }, [onDrag]);
  var handleChange = function handleChange(visible) {
    // visable is independent without drag effect.
    if (!onDrag) {
      setVisble(visible);
    } else {
      setVisble(true);
    }
  };
  function getArrowOffsetToken(options) {
    var contentRadius = options.contentRadius,
      limitVerticalRadius = options.limitVerticalRadius;
    var arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    var arrowOffsetVertical = limitVerticalRadius ? MAX_VERTICAL_CONTENT_RADIUS : arrowOffset;
    return {
      arrowOffsetHorizontal: arrowOffset,
      arrowOffsetVertical: arrowOffsetVertical
    };
  }
  function getOverflowOptions(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) {
      return {
        adjustX: false,
        adjustY: false
      };
    }
    var overflow = autoAdjustOverflow && _typeof(autoAdjustOverflow) === 'object' ? autoAdjustOverflow : {};
    var baseOverflow = {};
    switch (placement) {
      case 'top':
      case 'bottom':
        baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
        baseOverflow.shiftY = true;
        baseOverflow.adjustY = true;
        break;
      case 'left':
      case 'right':
        baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
        baseOverflow.shiftX = true;
        baseOverflow.adjustX = true;
        break;
    }
    var mergedOverflow = _objectSpread(_objectSpread({}, baseOverflow), overflow);

    // Support auto shift
    if (!mergedOverflow.shiftX) {
      mergedOverflow.adjustX = true;
    }
    if (!mergedOverflow.shiftY) {
      mergedOverflow.adjustY = true;
    }
    return mergedOverflow;
  }
  function getPlacements(config) {
    var arrowWidth = config.arrowWidth,
      autoAdjustOverflow = config.autoAdjustOverflow,
      arrowPointAtCenter = config.arrowPointAtCenter,
      offset = config.offset,
      borderRadius = config.borderRadius,
      visibleFirst = config.visibleFirst;
    var halfArrowWidth = arrowWidth / 2;
    var placementMap = {};
    Object.keys(PlacementAlignMap).forEach(function (key) {
      var template = arrowPointAtCenter && ArrowCenterPlacementAlignMap[key] || PlacementAlignMap[key];
      var placementInfo = _objectSpread(_objectSpread({}, template), {}, {
        offset: [0, 0],
        dynamicInset: true
      });
      placementMap[key] = placementInfo;

      // Disable autoArrow since design is fixed position
      if (DisableAutoArrowList.has(key)) {
        placementInfo.autoArrow = false;
      }

      // Static offset
      switch (key) {
        case 'top':
        case 'topLeft':
        case 'topRight':
          placementInfo.offset[1] = -halfArrowWidth - offset;
          break;
        case 'bottom':
        case 'bottomLeft':
        case 'bottomRight':
          placementInfo.offset[1] = halfArrowWidth + offset;
          break;
        case 'left':
        case 'leftTop':
        case 'leftBottom':
          placementInfo.offset[0] = -halfArrowWidth - offset;
          break;
        case 'right':
        case 'rightTop':
        case 'rightBottom':
          placementInfo.offset[0] = halfArrowWidth + offset;
          break;
      }

      // Dynamic offset
      var arrowOffset = getArrowOffsetToken({
        contentRadius: borderRadius,
        limitVerticalRadius: true
      });
      if (arrowPointAtCenter) {
        switch (key) {
          case 'topLeft':
          case 'bottomLeft':
            placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
            break;
          case 'topRight':
          case 'bottomRight':
            placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
            break;
          case 'leftTop':
          case 'rightTop':
            placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
            break;
          case 'leftBottom':
          case 'rightBottom':
            placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
            break;
        }
      }

      // Overflow
      placementInfo.overflow = getOverflowOptions(key, arrowOffset, arrowWidth, autoAdjustOverflow);

      // VisibleFirst
      if (visibleFirst) {
        placementInfo.htmlRegion = 'visibleFirst';
      }
    });
    return placementMap;
  }
  var tooltipPlacements = React.useMemo(function () {
    var mergedArrowPointAtCenter = false;
    var autoAdjustOverflow = true;
    return getPlacements({
      arrowPointAtCenter: mergedArrowPointAtCenter,
      autoAdjustOverflow: autoAdjustOverflow,
      arrowWidth: 0,
      borderRadius: 8,
      offset: 0,
      visibleFirst: true
    });
  }, [arrowPointAtCenter]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({
      prefixCls: styles.molyTooltip,
      trigger: ['hover'],
      getTooltipContainer: function getTooltipContainer(t) {
        return t;
      },
      placement: "top",
      overlay: tipFormatter(value),
      overlayInnerStyle: {
        minHeight: 'auto'
      },
      ref: tooltipRef,
      visible: _visible,
      onVisibleChange: handleChange,
      builtinPlacements: tooltipPlacements
    }, restProps), {}, {
      children: children
    }))
  });
};
export var handleRender = function handleRender(node, props, tipFormatter) {
  return /*#__PURE__*/_jsx(HandleTooltip, {
    value: props.value,
    onDrag: props.dragging,
    tipFormatter: tipFormatter,
    children: node
  });
};
var TooltipSlider = function TooltipSlider(_ref) {
  var tipFormatter = _ref.tipFormatter,
    tipProps = _ref.tipProps,
    props = _objectWithoutProperties(_ref, _excluded2);
  var tipHandleRender = function tipHandleRender(node, handleProps) {
    return /*#__PURE__*/_jsx(HandleTooltip, _objectSpread(_objectSpread({
      value: handleProps.value,
      onDrag: handleProps.dragging,
      tipFormatter: tipFormatter
    }, tipProps), {}, {
      children: node
    }));
  };
  return /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, props), {}, {
    handleRender: tipHandleRender
  }));
};
export default TooltipSlider;